import React, { cloneElement, useState } from 'react';
import { Sheet } from '@paypalcorp/pp-react';
import { PropTypes } from 'prop-types';

const SheetTrigger = (props) => {
  const { children, TriggerComponent, sheetProps } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      {cloneElement(TriggerComponent, {
        ...TriggerComponent.props,
        onClick: handleOpen,
      })}
      <Sheet
        isOpen={isOpen}
        onClose={handleClose}
        skipFormFocus={true}
        {...sheetProps}
      >
        {children}
      </Sheet>
    </>
  );
};

SheetTrigger.propTypes = {
  children: PropTypes.element.isRequired,
  TriggerComponent: PropTypes.element.isRequired,
  sheetProps: PropTypes.object,
};

export default SheetTrigger;
